module.exports = __webpack_public_path__ + "img/netcore.dfc51761.png";